module.exports = __webpack_public_path__ + "static/media/video_thumb.55c7495a.jpg";